import { parsePhoneNumberFromString, formatIncompletePhoneNumber } from 'libphonenumber-js';

export function formatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber;

  // Verifica se já está no formato E.164 (começa com +)
  if (phoneNumber.startsWith('+')) {
    return phoneNumber;
  }

  // Tenta parsear como número BR
  const parsed = parsePhoneNumberFromString(phoneNumber, 'BR');

  if (parsed && parsed.isValid()) {
    // Retorna no formato E.164: +55219XXXXXXXX
    return parsed.format('E.164');
  }

  // Fallback para números "inválidos" para a lib (ex: móveis antigos com 8 dígitos)
  // Tenta extrair DDD e número manualmente se tiver 10 ou 11 dígitos (após remover +55 se houver)
  // Remove caracteres não numéricos
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Se começar com 55 e tiver 12 ou 13 dígitos, prefixa com +
  if (cleaned.startsWith('55') && (cleaned.length === 12 || cleaned.length === 13)) {
    return `+${cleaned}`;
  }

  // Se tiver 10 ou 11 dígitos (número brasileiro sem DDI), prefixa com +55
  if (cleaned.length === 10 || cleaned.length === 11) {
    return `+55${cleaned}`;
  }

  return phoneNumber;
}

export function normalizePhoneInput(input: string): string {
  return formatIncompletePhoneNumber(input, 'BR');
}

export function validatePhone(phoneNumber: string): boolean {
  const parsed = parsePhoneNumberFromString(phoneNumber, 'BR');
  return parsed ? parsed.isValid() : false;
}